<div class="container-fluid py-3">
  <div class="row">

    <div class="col-12 mb-3">
      <h4><b>
        Encuestas
      </b></h4>
    </div>

    <div class="col-12 rounded bg-white py-3 text-end mb-4">
      <button
        (click)="open()"
        class="btn btn-success rounded-circle me-2">
        <i class="material-icons mt-1">add</i>
      </button>

      <button
        (click)="surveyService.getAll(neighborhoodId)"
        class="btn btn-primary rounded-circle me-2">
        <i class="material-icons mt-1">refresh</i>
      </button>

    </div>

    <div class="col-12">
      <div class="row">

        @if (surveyService.loading) {
          <div class="col-12 text-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }

        @if (!surveyService.loading && surveyService.surveys.length === 0) {
          <div class="col-12 text-center">
            <p class="text-secondary">No hay encuestas registradas</p>
          </div>
        }

        @if (!surveyService.loading) {
          @for (survey of surveyService.surveys; track $index) {
            <div class="col-12 bg-white mb-3 rounded px-4 py-3">
              <div class="row">

                <div class="col-12 col-md">
                  <div class="row">

                    <div class="col-12">
                      <h5><b>{{ survey.title }}</b></h5>
                    </div>

                    <div class="col-12 col-md mb-2">
                      {{ survey.content }}
                    </div>

                    <div class="col-12 fw-200 mb-2">
                      Número de participantes: {{ survey.total }}
                    </div>

                    <div class="col-12">

                      <span
                        class="badge rounded-pill me-2"
                        [ngClass]="{
                          'text-bg-success': survey.status,
                          'text-bg-secondary': !survey.status
                        }">
                        {{ survey.status ? 'Publicado' : 'No publicado' }}
                      </span>

                      <span
                        class="badge rounded-pill"
                        [ngClass]="{
                          'text-bg-success': survey.status,
                          'text-bg-secondary': !survey.status
                        }">
                        {{ survey.dueDate | dateToMoment: 'ddd DD MMM yyyy HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
                      </span>

                    </div>

                  </div>
                </div>

                <div class="col-12 col-md d-flex align-items-center justify-content-end">
                  <a
                    [routerLink]="[survey.surveyId]"
                    class="btn btn-sm btn-light rounded-circle me-2"
                    placement="top"
                    ngbTooltip="Ver más">
                    <i class="material-icons mt-1">more_vert</i>
                  </a>

                  @if(!survey.status) {
                    <button
                      (click)="open(survey)"
                      class="btn btn-light rounded-circle me-2">
                      <i class="material-icons mt-1">edit</i>
                    </button>

                  }

                  <button
                    (click)="delete(survey)"
                    class="btn btn-danger rounded-circle me-2">
                    <i class="material-icons mt-1">delete</i>
                  </button>
                </div>

              </div>
            </div>
          }
        }

      </div>
    </div>

  </div>
</div>
